function isMobileDevice() {
  // Check useragent is mobile
  return /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    window.navigator.userAgent
  )

  // Check device has touchscreen
  // if (
  //   "ontouchstart" in window ||
  //   (window.DocumentTouch && document instanceof window.DocumentTouch)
  // ) {
  //   return true;
  // }
  // const prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  // const mq = (query) => window.matchMedia(query).matches;
  // const query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join(
  //   ""
  // );
  // return mq(query);
}

export default isMobileDevice
